(function ($) {
  "use strict";
  $(function () {

    /**
     * @todo скорее всего лишнее, тк раньше перезагружало каталог аякса через календарь
     */
    window.stupidCatalogReload = function () {
      try{
        let superStupidWay = $(document).find('.js-catalog-menu-day.day_active');
        superStupidWay[0].click();
      }catch (e){

      }
    }

    window.printMobileAdrress = function (strAddress) {
      strAddress = strAddress.replace('Москва, ', '').replace('улица ', '').replace('Улица ');
      $(document).find('[data-entity="popup-address-value-mobile"]').text(strAddress);
    }

    $(document).on('click', '[data-action="stoplist-remove-items"]', function (e) {
      let revealWrapper = $(e.target).parents('.reveal');
      let data = new FormData();
      let dontReload = $(e.target).data('is-cart') === 'Y';
      let redirectCatalog = $(e.target).data('is-redirect-catalog') === 'Y';

      data.append('action', 'deleteAllStopped');

      revealWrapper.find('button').attr('disabled', true);
      $.ajax({
        method: 'POST',
        url: '/ajax/stopListProvider.php',
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function () {
          /** Возьму другое - убрать стоп-позиции и отправить в каталог*/
          if (redirectCatalog) {
            window.location.href = '/';
          } else {
            /** когда в каталоге - обновляем корзины */
            if (!dontReload) {
              window.reloadBasket(undefined, undefined, true);
              window.stupidCatalogReload();
            } else {
              /** а когда в другом месте - перезагружаем страницу */
              location.reload(true);
            }
            revealWrapper.foundation('close');
          }
        },
        error: function (data) {
          console.log(data);
        }
      });
    });

    window.changeSwitchBlocks = function (priceToday) {
      console.log('price: ' + priceToday);
      let $today = $(document).find('[data-entity="popup-address-today"]');
      let $noway = $(document).find('[data-entity="popup-address-noway"]');
      if (priceToday === 1) {
        $today.css('display', 'none');
        $noway.css('display', 'block');
      } else {
        $noway.css('display', 'none');
        $today.css('display', 'block');
      }
    }


    $(document).on('click', '[data-action="flip-address"]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let button = $(e.target);
      let isReload = button.data('reload') === 'Y';
      let data = new FormData();
      data.append('action', 'flipAddress');
      $.ajax({
        method: 'POST',
        url: '/ajax/stopListProvider.php',
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function (data) {
          if (data.result) {
            if (!isReload) {
              let addrStringBlock = $('[data-entity="popup-address-value"]');
              addrStringBlock.text(data.result.PRINTABLE);
              window.printMobileAdrress(data.result.PRINTABLE);
              if (!data.result.SELF_PICKUP) {
                $(document).find('[data-entity="popup-address-price-today"]').text(data.result.PRICES.todayPrice);
                $(document).find('[data-entity="popup-address-price-tomorrow"]').text(data.result.PRICES.tomorrowPrice);

                window.changeSwitchBlocks(data.result.PRICES.todayPrice);

                $(document).find('[data-entity="popup-address-price-wrapper"]').fadeIn(200);
              } else {
                $(document).find('[data-entity="popup-address-price-wrapper"]').fadeOut(200);
              }
              window.stupidCatalogReload();
            } else {
              $(e.target).parents('.reveal').foundation('close');
              if (
                data.result.ADDRESS.street
                ||
                data.result.ADDRESS.house
              ) {
                let oldAddress = data.result.ADDRESS.street;
                if (data.result.ADDRESS.house) {
                  oldAddress += ", д" + data.result.ADDRESS.house;
                }
                if (oldAddress !== $(document).find('#full_address').text()) {
                  $(document).find('#address').val(data.result.ADDRESS.street);
                  $(document).find('#house').val(data.result.ADDRESS.house);
                  $(document).find('#house').trigger('blur');
                  if ($(document).find('.x-form-address-submit-btm').length) {
                    $(document).find('.x-form-address-submit-btm').trigger('click');
                  }
                }
              }
              //location.reload(true);
            }
          } else {
            location.reload(true);
          }
          $(e.target).parents('.reveal').foundation('close');
        },
        error: function () {
          location.reload(true);
        }
      });
    });

    if ($(document).find('.x-header-blocks-location').length) {
      let stopListItemsWrapper = $('#stoplist-block-items-wrapper');
      if (stopListItemsWrapper.length) {
        stopListItemsWrapper.html('');
      }
      $.ajax({
        method: 'GET',
        url: '/ajax/stopListProvider.php',
        data: {
          'action': 'reload',
          'takeAnother': "Y"
        },
        cache: false,
        contentType: 'json',
        dataType: 'html',
        success: function (data) {
          $(document).find('#stoplist-block-items-reveal').parent('.reveal-overlay').remove();
          stopListItemsWrapper.html(data);
          if ($(document).find('#stoplist-block-items-reveal').length) {
            $(document).find('#stoplist-block-items-reveal').foundation();
            $(document).find('#stoplist-block-items-reveal').foundation('open');
          }
        },
        error: function (data) {
          console.log(data);
        }
      });
    }

    $(document).on('click', '[data-action="popup-address-pickup-change"]', function (e) {
      let selector = $(document).find('[data-entity="popup-address-pickup-select"]');
      let data = new FormData();
      data.append('action', 'savePickup');
      data.append('branchID', selector.val());
      let stopListItemsWrapper = $(document).find('#stoplist-block-items-wrapper');
      if (stopListItemsWrapper.length) {
        stopListItemsWrapper.html('');
      }
      let calendarWrapper = $('[data-entity="catalog-calendar-wrapper"]');

      if (calendarWrapper.data('date-block')==='N'){
        calendarWrapper.find('.day__blocked').removeClass('day__blocked').addClass('js-catalog-menu-day');
      }
      $.ajax({
        method: 'POST',
        url: '/ajax/stopListProvider.php',
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function (data) {
          if (data.result.PRINT) {
            window.stupidCatalogReload();
            window.changeSwitchBlocks(data.result.PRICES.todayPrice);
            let addrStringBlock = $(document).find('[data-entity="popup-address-value"]');
            addrStringBlock.text(data.result.PRINT);
            window.printMobileAdrress(data.result.PRINT);
            $(document).find('[data-entity="popup-address-price-wrapper"]').fadeOut(200);
            selector.parents('.reveal').foundation('close');
            $(document).find('[data-popup-panel="user-address"]').css('display', 'block');
            $(document).find('[data-popup-panel="delivery-branch"]').css('display', 'none');
            window.stopListPreloaded = undefined;
            if (stopListItemsWrapper.length) {
              let _data = new FormData();
              _data.append('action', 'reload');
              $.ajax({
                method: 'GET',
                url: '/ajax/stopListProvider.php',
                data: {'action': 'reload'},
                cache: false,
                contentType: 'json',
                dataType: 'html',
                success: function (data) {
                  $(document).find('#stoplist-block-items-reveal').parent('.reveal-overlay').remove();
                  stopListItemsWrapper.html(data);
                  if ($(document).find('#stoplist-block-items-reveal').length) {
                    $(document).find('#stoplist-block-items-reveal').foundation();
                    $(document).find('#stoplist-block-items-reveal').foundation('open');
                  }
                },
                error: function (data) {
                  console.log(data);
                }
              });
            }
          }
          window.updateBranchesGroup();
        },
        error: function (data) {
          console.log(data);
          $(document).find('[data-popup-panel="user-address"]').css('display', 'block');
          $(document).find('[data-popup-panel="delivery-branch"]').css('display', 'none');
        }
      });
    });
  });
})(jQuery);



